import { render, staticRenderFns } from "./adminTaxonomy.vue?vue&type=template&id=4ecf2f57"
import script from "./adminTaxonomy.vue?vue&type=script&lang=js"
export * from "./adminTaxonomy.vue?vue&type=script&lang=js"
import style0 from "./adminTaxonomy.vue?vue&type=style&index=0&id=4ecf2f57&prod&lang=css"
import style1 from "./adminTaxonomy.vue?vue&type=style&index=1&id=4ecf2f57&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports